import { TicketSelectorOption } from "./ticket-selector-option.interface";

export const tickets_passes: TicketSelectorOption = {
  titleKey: "selector_tickets_and_passes_title",
  descriptionKey: "selector_tickets_and_passes_description"
};

export const flexible_tickets: TicketSelectorOption = {
  titleKey: "selector_flexible_title",
  descriptionKey: "selector_flexible_description"
};

export const pay_as_you_go: TicketSelectorOption = {
  titleKey: "selector_pay_as_you_go_title",
  descriptionKey: "selector_pay_as_you_go_description"
};
